import React, { useState } from 'react';
import { 
    SpeedDial, 
    SpeedDialAction, 
    SpeedDialIcon,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';
import { 
    Person, 
    DirectionsCar, 
    Hotel, 
    Flight,
    Business,
    Close
} from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { COLORS } from '../../settings/themeSettings';

const QuickActions = ({ currentContext = null }) => {
    const [open, setOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedAction, setSelectedAction] = useState(null);
    const navigateTo = useNavigate();

    const actions = [
        {
            icon: <Person />,
            name: 'Nouveau Client',
            action: () => navigateTo('/billeterie/portefeuil/ajout'),
            color: '#1976d2'
        },
        {
            icon: <DirectionsCar />,
            name: 'Nouveau Circuit',
            action: () => navigateTo('/ajout/dossier/circuit'),
            color: '#388e3c'
        },
        {
            icon: <Hotel />,
            name: 'Nouveau Séjour',
            action: () => navigateTo('/ajout/dossier/sejour'),
            color: '#f57c00'
        },
        {
            icon: <Flight />,
            name: 'Nouveau Billet',
            action: () => {
                if (currentContext?.clientId) {
                    navigateTo(`/billeterie/factures/nouveau/${currentContext.clientId}`);
                } else {
                    navigateTo('/facturation/nouvelle/billetterie');
                }
            },
            color: '#7b1fa2'
        },
        {
            icon: <Business />,
            name: 'Nouvelle Facture',
            action: () => {
                if (currentContext?.clientId) {
                    navigateTo(`/billeterie/factures/nouveau/${currentContext.clientId}`);
                } else {
                    navigateTo('/facturation/nouvelle/billetterie');
                }
            },
            color: '#d32f2f'
        }
    ];

    const handleActionClick = (actionFn) => {
        actionFn();
        setOpen(false);
    };

    const handleDialogAction = () => {
        // Rediriger vers la sélection de client d'abord
        navigateTo('/billeterie/portefeuil');
        setDialogOpen(false);
    };

    return (
        <>
            <SpeedDial
                ariaLabel="Actions rapides"
                sx={{ 
                    position: 'fixed', 
                    bottom: 24, 
                    right: 24,
                    '& .MuiFab-primary': {
                        backgroundColor: COLORS.secondary,
                        '&:hover': {
                            backgroundColor: COLORS.secondary,
                            opacity: 0.9
                        }
                    }
                }}
                icon={<SpeedDialIcon openIcon={<Close />} />}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={() => handleActionClick(action.action)}
                        sx={{
                            '& .MuiSpeedDialAction-fab': {
                                backgroundColor: action.color,
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: action.color,
                                    opacity: 0.9
                                }
                            }
                        }}
                    />
                ))}
            </SpeedDial>


        </>
    );
};

export default QuickActions;
